import _ from 'underscore';

export default function (title, slideIndex) {
    let slideIndexParam = slideIndex;
    // when there is  a title but no supertag,
    // title is the second part of the url
    if (_.isUndefined(title) && _.isNaN(slideIndex)) {
        slideIndexParam = 1;
        // when there is  a title with a digit in it
    } else if (slideIndex === null) {
        let isNan = Number(title);
        isNan = _.isNaN(isNan);

        if (isNan) {
            slideIndexParam = 1;
        } else {
            slideIndexParam = title;
        } // when there is no slideIndex specified
    } else if (_.isNaN(Number(slideIndex))) {
        slideIndexParam = 1;
    }
    return slideIndexParam;
}


